export var PaymentVendor;
(function (PaymentVendor) {
    PaymentVendor["AppleAppStore"] = "AppleAppStore";
    PaymentVendor["GooglePlayStore"] = "GooglePlayStore";
    PaymentVendor["RevenueCat"] = "RevenueCat";
    PaymentVendor["Stripe"] = "Stripe";
})(PaymentVendor || (PaymentVendor = {}));
//# sourceMappingURL=payment-vendor.const.js.map